import { combineReducers } from 'redux'
import module from './module'
import course from './course'
import viewer from './viewer'

import userMetadata from './userMetadata'
import quizzes from './userQuiz'
import surveyQuiz from './userSurvey'
import surveyETC from './userSurveyETC'
import feedback from './userFeedback'
import completions from './userCompletions'

import search from './search'


import {reducer as notifications} from 'react-notification-system-redux';


/**
 * perhaps we need to make reducers dynamic, if there is no booster then a state is not create, but... :
 * https://stackoverflow.com/questions/32968016/how-to-dynamically-load-reducers-for-code-splitting-in-a-redux-application
 * 
 */


const user = combineReducers({
	metadata: userMetadata,
	quizzes: quizzes,	
	survey: surveyQuiz,
	surveyETC: surveyETC,
	feedback: feedback,
	completions: completions
})



const rootReducer = combineReducers({
	module,
	course,
	user,
	viewer,
	notifications,
	search
})

export default rootReducer
